export default __webpack_public_path__ + "static/media/infographic-eclaim-success.5ae63e53.svg";